import { render, staticRenderFns } from "./ProductListSlotRight.vue?vue&type=template&id=149507fb&"
import script from "./ProductListSlotRight.vue?vue&type=script&lang=ts&"
export * from "./ProductListSlotRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports